module.exports = "/_next/static/images/slide16-fba4ba86b03adcbf2140d052fc888253.webp";